/*
 *		Copyright (c) 2011-2015 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .factory('multiResultsModal', ['$modal', '$translate', function($modal, $translate){

        return function(multiResults, selectionCountSummary, constructor, action){
            var actionTitleMap = {
                copy: 'Copying %{summary}',
                move: 'Moving %{summary}',
                restore: 'Restoring %{summary}',
                notarize: 'node_notarization_multi_results_dialog_title',
                delete: 'Deleting %{summary}',
                unsubscribe: 'Unsubscribing from %{summary}',
                unsubscribeDelete: 'Unsubscribing or Deleting %{summary}',
                revokeAll: 'Revoking all links for %{summary}'
            };
            return $modal.open({
                domOptions: {
                    modalTitle: $translate.instant(actionTitleMap[action], {summary: selectionCountSummary}),
                    modalType: 'notify',
                    modalActionButton: $translate.instant('Close'),
                    modalBodyTemplate: 'nodes/multi_select/results/_container'
                },
                backdrop: 'static',
                keyboard: false,
                windowClass: 'multi-results-dialog',
                controller: 'MultiResultsModalController',
                resolve: {
                    multiResults: function() {
                        return multiResults;
                    },
                    constructor: function() {
                        return constructor;
                    },
                    action: function() {
                        return action;
                    }
                }
            }).result;
        };
    }]);


